export default __webpack_public_path__ + "static/media/IMG_0028.c8d32bc6.JPG";